import React from 'react';
import { Button } from './ui/button';
import { Mail, MapPin } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
import { PhoneNumber } from './PhoneNumber';
export function CTASection() {
  const {
    t
  } = useLanguage();
  return <section id="contact" className="py-20 md:py-28 lg:py-40 relative overflow-hidden" data-id="element-17">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-18">
        <img src="https://cdn.magicpatterns.com/uploads/mJxC4jQMkkUB1xRkzRfPyz/nazarizal-mohammad-RmwNno4cpZ0-unsplash.jpg" alt="Palm Oil Plantation" className="w-full h-full object-cover object-center scale-105" style={{
        filter: 'blur(3px)'
      }} data-id="element-19" />
        {/* Overlay lebih tipis agar foto terlihat */}
        <div className="absolute inset-0 bg-gradient-to-b from-brand-green/70 via-brand-green/60 to-forest-950/80" data-id="element-20" />
      </div>

      {/* Mesh Grid Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff04_1px,transparent_1px),linear-gradient(to_bottom,#ffffff04_1px,transparent_1px)] bg-[size:32px_32px] pointer-events-none z-[1]" data-id="element-21" />

      {/* Gold Accent Line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-px bg-gradient-to-r from-transparent via-brand-gold/60 to-transparent z-[1]" data-id="element-22" />

      {/* Glow Orbs */}
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-brand-gold/10 rounded-full blur-3xl pointer-events-none translate-x-1/3 translate-y-1/3 z-[1]" data-id="element-23" />

      <div className="container mx-auto px-6 md:px-8 text-center relative z-10" data-id="element-24">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/20 bg-white/10 backdrop-blur-sm mb-8" data-id="element-25">
          <span className="w-1.5 h-1.5 rounded-full bg-brand-gold animate-pulse" data-id="element-26" />
          <span className="text-white text-xs font-semibold tracking-wide uppercase" data-id="element-27">
            {t.cta.badge}
          </span>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-6 leading-tight" data-id="element-28">
          {t.cta.headline}
        </h2>

        <p className="text-lg md:text-xl text-white/75 max-w-2xl mx-auto mb-10 md:mb-12 font-light leading-relaxed" data-id="element-29">
          {t.cta.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-5 mb-8" data-id="element-30">
          <Button onClick={() => window.open('https://wa.me/628127634091?text=Halo%2C+saya+ingin+menjadwalkan+demo+sawit-net', '_blank')} className="h-14 px-10 bg-brand-gold hover:bg-gold-400 text-forest-950 font-bold text-lg rounded-xl transition-all shadow-xl shadow-brand-gold/30 hover:shadow-2xl hover:-translate-y-0.5" data-id="element-31">
            {t.cta.cta1}
          </Button>
          <Button variant="outline" onClick={() => window.open('https://wa.me/628127634091?text=Halo%2C+saya+ingin+menghubungi+tim+sales+sawit-net', '_blank')} className="h-14 px-10 border-white/30 bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 hover:border-white/50 font-medium text-lg rounded-xl transition-all" data-id="element-32">
            {t.cta.cta2}
          </Button>
        </div>

        <p className="text-xs text-white/50 mb-10 md:mb-20 font-medium tracking-wide" data-id="element-33">
          {t.cta.trustLine}
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-8 md:gap-16 text-white/60 text-sm font-medium border-t border-white/10 pt-12 max-w-4xl mx-auto" data-id="element-34">
          <div className="flex items-center justify-center gap-3" data-id="element-35">
            <Mail className="w-4 h-4 text-white/40" data-id="element-36" />
            <span data-id="element-37">layanan@netkrida.co.id</span>
          </div>
          <div className="flex items-center justify-center gap-3" data-id="element-38">
            <MapPin className="w-4 h-4 text-white/40" data-id="element-39" />
            <span data-id="element-40">Pekanbaru, Riau</span>
          </div>
        </div>
      </div>
    </section>;
}